// removed by extract-text-webpack-plugin
module.exports = {"container":"components-Login-index-container-1uwyo","content":"components-Login-index-content-2ZH4a","main":"components-Login-index-main-1E7tU","tabs":"components-Login-index-tabs-3Bexe","submit":"components-Login-index-submit-2JIBx","icon_qq":"components-Login-index-icon_qq-1PYdW","icon_wechat":"components-Login-index-icon_wechat-3vO79","getCaptcha":"components-Login-index-getCaptcha-1WOJf"};


//////////////////
// WEBPACK FOOTER
// ./components/Login/index.css
// module id = 1897
// module chunks = 0